/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh.pages

import japgolly.scalajs.react._
import japgolly.scalajs.react.extra.router.RouterCtl
import japgolly.scalajs.react.vdom.html_<^._
import net.scalytica.blaargh.components.Articles
import net.scalytica.blaargh.models.Config
import net.scalytica.blaargh.pages.Views.{FilterCriteria, View}
import net.scalytica.blaargh.styles.BlaarghBootstrapCSS
import scalacss.ScalaCssReact._

import scala.concurrent.Future

object HomePage {

  case class Props(futureConf: Future[Config], ctl: RouterCtl[View])

  class Backend($ : BackendScope[Props, Unit]) {

    // scalastyle:off method.length magic.number
    def render(props: Props) = {
      <.div(^.key :="hp_1",
        <.div(^.key :="hp_2",
          ^.className := "top",
          <.div(^.key :="hp_2-1", ^.className := "layer logo"),
          <.div(^.key :="hp_2-2",
            ^.className := "layer layer1",
            <.div(^.key :="hp_2-2-1",^.className := "layer-element moose")
          ),
          <.div(^.key :="hp_2-3",
            ^.className := "layer layer2",
            <.div(^.key :="hp_2-3-1", ^.className := "layer-element butterfly2"),
            <.div(^.key :="hp_2-3-2", ^.className := "layer-element butterfly5")
          ),
          <.div(^.key :="hp_2-4",
            ^.className := "layer layer3",
            <.div(^.key :="hp_2-4-1", ^.className := "layer-element butterfly3")
          ),
          <.div(^.key :="hp_2-5",
            ^.className := "layer layer4",
            <.div(^.key :="hp_2-5-1", ^.className := "layer-element butterfly4")
          ),
          <.div(^.key :="hp_2-6",
            ^.className := "layer layer5",
            <.div(^.key :="hp_2-6-1",^.className := "layer-element butterfly6")
          )
        ),
        <.div(^.key :="hp_3",
          ^.className := "content about",
          ^.id := Views.About.basePath.stripPrefix("#"),
          <.div(^.key :="hp_3-1", BlaarghBootstrapCSS.container, AboutPage(props.futureConf))
        ),
        <.div(^.key :="hp_4",
          ^.className := "content publications",
          ^.id := Views.Publications.basePath.stripPrefix("#"),
          <.div(^.key :="hp_4-1",
            BlaarghBootstrapCSS.container,
            Articles(FilterCriteria.PublicationsFilter, props.ctl)
          )
        ),
        <.div(^.key :="hp_5",
          ^.className := "content gallery",
          ^.id := Views.Gallery.basePath.stripPrefix("#"),
          <.div(^.key :="hp_5-1",
            BlaarghBootstrapCSS.container,
            Articles(FilterCriteria.GalleryFilter, props.ctl)
          )
        )
      )
    }
    // scalastyle:on method.length magic.number
  }

  val component =
    ScalaComponent.builder[Props]("Home").stateless.renderBackend[Backend].build

  def apply(fc: Future[Config], ctl: RouterCtl[View]) =
    component(Props(fc, ctl))
}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/pages/HomePage.scala